import React, { useEffect } from 'react';
import './ScrollableSlider.scss';

interface ScrollableSliderProps {
  children?: React.ReactNode;
}

/**
 * Reusabe scrollable slider component
 * @param param0.children  children to be rendered
 * @returns
 */
const ScrollableSlider: React.FC<ScrollableSliderProps> = ({ children }) => {
  const [isDown, setIsDown] = React.useState<boolean>(false);
  const [startX, setStartX] = React.useState<number>(0);
  const [scrollLeft, setScrollLeft] = React.useState<number>(0);
  const [slider, setSlider] = React.useState<any>(null);
  const cRef = React.useRef<HTMLUListElement>(null);

  useEffect(() => {
    scrollToSelectedTab();
    setSlider(cRef.current);
  }, []);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDown(true);
    setStartX(e.pageX - slider.offsetLeft);
    setScrollLeft(slider.scrollLeft);
    cRef.current?.classList.add('active');
  };

  const handleMouseLeave = () => {
    setIsDown(false);
    cRef.current?.classList.remove('active');
  };

  const handleMouseUp = () => {
    setIsDown(false);
    cRef.current?.classList.remove('active');
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1;
    slider.scrollLeft = scrollLeft - walk;
  };

  const scrollToSelectedTab = () => {
    const element = cRef.current?.querySelector('.selected');
    element?.scrollIntoView?.({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  };

  return (
    <ul
      role="listbox"
      className="carousel"
      ref={cRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      {children}
    </ul>
  );
};

export default ScrollableSlider;
